'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'dumpster';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f793';
var svgPathData = 'M304 64l106.4 0 18.2 96L304 160l0-96zM447.7 192l.6 0 61.7 0 32.2 0 1.1 0 32.6 0-6.4-32L544 32 424 32c-.2 0-.4 0-.6 0L288 32s0 0 0 0s0 0 0 0L152.3 32c-.2 0-.4 0-.6 0L32 32 6.4 160 0 192l32.6 0 1.1 0L66 192l61.7 0 .6 0L288 192l159.7 0zM69.8 224l-32.2 0 3.8 32L16 256 0 256l0 32 16 0 29.1 0L64 448.9 64 464l0 16 32 0 0-16 0-16 384 0 0 16 0 16 32 0 0-16 0-15.1L530.9 288l29.1 0 16 0 0-32-16 0-25.3 0 3.8-32-32.2 0L483.7 416 92.3 416 69.8 224zM272 64l0 96-124.7 0 18-96L272 64zM132.7 64l-18 96L39 160 58.2 64l74.5 0zm385 0L537 160l-75.7 0L443 64l74.8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpster = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;